import Vue from 'vue'
import VueRouter from 'vue-router'
import VueRouterPrefetch from 'vue-router-prefetch'

// NavigationDuplicated 대응
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

Vue.use(VueRouter)
Vue.use(VueRouterPrefetch)

const CHART_VIEW_ALLOWLIST = ['top100', 'type', 'benefit', 'corp', 'annual', 'pre', 'check100', 'release30', 'travel30']
const TRAVEL_CHART_VIEW_ALLOWLIST = ['travel30', 'type', 'top100']

function decodeRouteParam (value) {
  try {
    return decodeURIComponent(String(value))
  } catch (e) {
    return String(value)
  }
}

function replaceLastPathSegment (path, value) {
  const parts = path.split('/')
  parts[parts.length - 1] = encodeURIComponent(value)
  return parts.join('/')
}

function getCleanNumericParam (value) {
  const decoded = decodeRouteParam(value)
  if (/^\d+$/.test(decoded)) return null

  const match = decoded.match(/^(\d+)[!"#$%&'()*+,\-.:;<=>?@[\\\]^_`{|}~\u2018\u2019\u201c\u201d]+$/)
  return match ? match[1] : false
}

function isSafeTagParam (value) {
  const decoded = decodeRouteParam(value)
  return decoded !== '' && decoded.length <= 100 && !/[\x00-\x1F\x7F<>"'`]/.test(decoded)
}

function getDynamicParamRedirect (to) {
  if (to.params && to.params.idx !== undefined) {
    const cleanIdx = getCleanNumericParam(to.params.idx)
    if (cleanIdx === null) return null
    if (cleanIdx !== false) {
      return { path: replaceLastPathSegment(to.path, cleanIdx), query: to.query, hash: to.hash, replace: true }
    }
    return { path: '/home', replace: true }
  }

  if (to.params && to.params.view !== undefined) {
    const view = decodeRouteParam(to.params.view)
    const allowlist = to.name === 'TravelChart' ? TRAVEL_CHART_VIEW_ALLOWLIST : CHART_VIEW_ALLOWLIST
    if (allowlist.indexOf(view) !== -1) return null
    return { path: '/home', replace: true }
  }

  if (to.params && to.params.tag !== undefined) {
    if (isSafeTagParam(to.params.tag)) return null
    return { path: '/home', replace: true }
  }

  return null
}

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation
 */

export default async function (/* { store, ssrContext } */) {
  const routes = (await (process.env.BUILD_TARGET === 'pc'
    ? import('src/pc/router/routes')
    : import('src/mobile/router/routes'))).default
  // const Router = new VueRouter({
  //   scrollBehavior: () => ({ x: 0, y: 0 }),
  //   routes,
  //
  //   // Leave these as is and change from quasar.conf.js instead!
  //   // quasar.conf.js -> build -> vueRouterMode
  //   // quasar.conf.js -> build -> publicPath
  //   mode: process.env.VUE_ROUTER_MODE,
  //   base: process.env.VUE_ROUTER_BASE
  // })
  const Router = new VueRouter({
    // linkActiveClass: 'active',
    scrollBehavior: (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition
      } else if (to.hash) {
        return {selector: to.hash}
      } else if (to.name === from.name && to.query !== from.query && (to.name.substr(0, 6) !== 'Search' && to.name.substr(0, 5) !== 'Chart')) {
        return {x: 0, y: 0}
      } else if (to.name === from.name) {
        if (from.name === 'ChartView') {
          if (from.params !== to.params || from.query.date !== to.query.date) return {x: 0, y: 0}
        }
        return false
      } else {
        return {x: 0, y: 0}
      }
    },
    routes, // short for routes: routes
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE,
    hash: false,
  })

  Router.beforeEach((to, from, next) => {
    const redirect = getDynamicParamRedirect(to)
    if (redirect) {
      next(redirect)
      return
    }
    next()
  })

  return Router
}
